import { render, staticRenderFns } from "./PreExamsListAnswers.vue?vue&type=template&id=567f3e6e&"
import script from "./PreExamsListAnswers.vue?vue&type=script&lang=ts&"
export * from "./PreExamsListAnswers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports